import {
  GROUP_VULNS_FETCHING,
  GROUP_VULNS_FAIL,
  GROUP_VULNS_CLEAR_ERROR,
  GROUP_VULNS_CREATE_SUCCESS,
  GROUP_VULNS_ADD_SUCCESS,
  GROUP_VULNS_REMOVE_SUCCESS,
  GROUP_VULNS_DELETE_SUCCESS,
  GROUP_VULNS_RENAME_SUCCESS,
  GROUP_VULNS_EXPLORE_OPEN,
  GROUP_VULNS_EXPLORE_CLOSE,
  GROUP_VULNS_EXPLORE_SET_ACTIVE_TAB,
  GROUP_VULNS_EXPLORE_SET_HOSTS_PAGE,
  GROUP_VULNS_EXPLORE_SET_SERVICES_PAGE,
  GROUP_VULNS_EXPLORE_HOSTS_FETCHING,
  GROUP_VULNS_EXPLORE_HOSTS_SUCCESS,
  GROUP_VULNS_EXPLORE_HOSTS_FAIL,
  GROUP_VULNS_EXPLORE_SERVICES_FETCHING,
  GROUP_VULNS_EXPLORE_SERVICES_SUCCESS,
  GROUP_VULNS_EXPLORE_SERVICES_FAIL,
  GROUP_VULNS_EXPLORE_SHOW_UNGROUP_CONFIRMATION_MODAL,
  GROUP_VULNS_EXPLORE_HIDE_UNGROUP_CONFIRMATION_MODAL,
  GROUP_VULNS_EXPLORE_SET_SELECTED_HOST_IDS,
  GROUP_VULNS_EXPLORE_SET_SELECTED_SERVICE_IDS,
  GROUP_VULNS_EXPLORE_UPDATE_HOST_TAGS,
  GROUP_VULNS_EXPLORE_UPDATE_SERVICE_TAGS,
  GROUP_VULNS_EXPLORE_HOSTS_DELETE_SUCCESS,
  GROUP_VULNS_EXPLORE_SERVICES_DELETE_SUCCESS
} from './constants';

const normalizePage = (page) => {
  if (!Number.isFinite(page)) return 1;
  return page >= 1 ? Math.trunc(page) : 1;
};

const initialExploreState = {
  isOpen: false,
  activeTab: 0,
  payload: null,
  hosts: [],
  hostsMeta: null,
  hostsPage: 1,
  isFetchingHosts: false,
  selectedHostIds: [],
  services: [],
  servicesMeta: null,
  servicesPage: 1,
  isFetchingServices: false,
  selectedServiceIds: [],
  showUngroupConfirmationModal: false
};

export const initialState = {
  isFetching: false,
  error: false,
  errorMessage: '',
  lastAction: null,
  explore: { ...initialExploreState }
};

const exploreRoutePattern = /^\/vulns\/[^/]+\/groups\/[^/]+$/;
const isExploreGroupPath = (pathname = '') => exploreRoutePattern.test(pathname);

export default function groupVulns (state = initialState, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      const pathname = action?.payload?.location?.pathname ?? '';
      if (isExploreGroupPath(pathname)) return state;

      if (!state.explore?.isOpen && !state.explore?.payload) return state;

      return {
        ...state,
        explore: { ...initialExploreState }
      };
    }

    case GROUP_VULNS_FETCHING:
      return { ...state, isFetching: true, error: false, errorMessage: '' };

    case GROUP_VULNS_FAIL:
      return { ...state, isFetching: false, error: true, errorMessage: action.message || 'There was an error' };

    case GROUP_VULNS_CLEAR_ERROR:
      return { ...state, error: false, errorMessage: '' };

    case GROUP_VULNS_CREATE_SUCCESS:
    case GROUP_VULNS_ADD_SUCCESS:
    case GROUP_VULNS_REMOVE_SUCCESS:
    case GROUP_VULNS_DELETE_SUCCESS:
    case GROUP_VULNS_RENAME_SUCCESS:
      return { ...state, isFetching: false, error: false, errorMessage: '', lastAction: action.type };

    case GROUP_VULNS_EXPLORE_OPEN:
      return {
        ...state,
        explore: {
          ...initialExploreState,
          isOpen: true,
          payload: action.payload ?? null,
          showUngroupConfirmationModal: false
        }
      };

    case GROUP_VULNS_EXPLORE_SET_ACTIVE_TAB:
      return {
        ...state,
        explore: {
          ...state.explore,
          activeTab: typeof action.tab === 'number' ? action.tab : 0,
          selectedHostIds: [],
          selectedServiceIds: []
        }
      };

    case GROUP_VULNS_EXPLORE_SET_SELECTED_HOST_IDS:
      return {
        ...state,
        explore: {
          ...state.explore,
          selectedHostIds: action.ids
        }
      };

    case GROUP_VULNS_EXPLORE_SET_SELECTED_SERVICE_IDS:
      return {
        ...state,
        explore: {
          ...state.explore,
          selectedServiceIds: action.ids
        }
      };

    case GROUP_VULNS_EXPLORE_SET_HOSTS_PAGE:
      return {
        ...state,
        explore: {
          ...state.explore,
          hostsPage: normalizePage(action.page)
        }
      };

    case GROUP_VULNS_EXPLORE_SET_SERVICES_PAGE:
      return {
        ...state,
        explore: {
          ...state.explore,
          servicesPage: normalizePage(action.page)
        }
      };

    case GROUP_VULNS_EXPLORE_HOSTS_FETCHING:
      return {
        ...state,
        explore: {
          ...state.explore,
          isFetchingHosts: true
        }
      };

    case GROUP_VULNS_EXPLORE_HOSTS_SUCCESS:
      return {
        ...state,
        explore: {
          ...state.explore,
          hosts: action.hosts ?? [],
          hostsMeta: action.meta ?? null,
          hostsPage: normalizePage(action.meta?.page ?? state.explore?.hostsPage),
          isFetchingHosts: false
        }
      };

    case GROUP_VULNS_EXPLORE_HOSTS_FAIL:
      return {
        ...state,
        explore: {
          ...state.explore,
          hosts: [],
          hostsMeta: null,
          isFetchingHosts: false
        }
      };

    case GROUP_VULNS_EXPLORE_SERVICES_FETCHING:
      return {
        ...state,
        explore: {
          ...state.explore,
          isFetchingServices: true
        }
      };

    case GROUP_VULNS_EXPLORE_SERVICES_SUCCESS:
      return {
        ...state,
        explore: {
          ...state.explore,
          services: action.services ?? [],
          servicesMeta: action.meta ?? null,
          servicesPage: normalizePage(action.meta?.page ?? state.explore?.servicesPage),
          isFetchingServices: false
        }
      };

    case GROUP_VULNS_EXPLORE_SERVICES_FAIL:
      return {
        ...state,
        explore: {
          ...state.explore,
          services: [],
          servicesMeta: null,
          isFetchingServices: false
        }
      };

    case GROUP_VULNS_EXPLORE_SHOW_UNGROUP_CONFIRMATION_MODAL:
      return {
        ...state,
        explore: {
          ...state.explore,
          showUngroupConfirmationModal: true
        }
      };

    case GROUP_VULNS_EXPLORE_HIDE_UNGROUP_CONFIRMATION_MODAL:
      return {
        ...state,
        explore: {
          ...state.explore,
          showUngroupConfirmationModal: false
        }
      };

    case GROUP_VULNS_EXPLORE_UPDATE_HOST_TAGS: {
      const { hostIds, tagsToAdd, tagsToRemove } = action;
      return {
        ...state,
        explore: {
          ...state.explore,
          hosts: state.explore.hosts.map((row) => {
            const host = row?.value ?? row;
            const id = String(host?._id ?? host?.id ?? '');
            if (!hostIds.includes(id)) return row;
            const currentTags = Array.isArray(host?.tags) ? host.tags : [];
            const newTags = [
              ...currentTags.filter((t) => !tagsToRemove.includes(t)),
              ...tagsToAdd.filter((t) => !currentTags.includes(t))
            ];
            const updated = { ...host, tags: newTags };
            return row?.value === undefined ? updated : { ...row, value: updated };
          })
        }
      };
    }

    case GROUP_VULNS_EXPLORE_UPDATE_SERVICE_TAGS: {
      const { serviceIds, tagsToAdd, tagsToRemove } = action;
      return {
        ...state,
        explore: {
          ...state.explore,
          services: state.explore.services.map((row) => {
            const service = row?.value ?? row;
            const id = String(service?._id ?? service?.id ?? '');
            if (!serviceIds.includes(id)) return row;
            const currentTags = Array.isArray(service?.tags) ? service.tags : [];
            const newTags = [
              ...currentTags.filter((t) => !tagsToRemove.includes(t)),
              ...tagsToAdd.filter((t) => !currentTags.includes(t))
            ];
            const updated = { ...service, tags: newTags };
            return row?.value === undefined ? updated : { ...row, value: updated };
          })
        }
      };
    }

    case GROUP_VULNS_EXPLORE_HOSTS_DELETE_SUCCESS: {
      const { hostIds } = action;
      return {
        ...state,
        explore: {
          ...state.explore,
          hosts: state.explore.hosts.filter((row) => {
            const host = row?.value ?? row;
            const id = String(host?._id ?? host?.id ?? '');
            return !hostIds.includes(id);
          }),
          selectedHostIds: []
        }
      };
    }

    case GROUP_VULNS_EXPLORE_SERVICES_DELETE_SUCCESS: {
      const { serviceIds } = action;
      return {
        ...state,
        explore: {
          ...state.explore,
          services: state.explore.services.filter((row) => {
            const service = row?.value ?? row;
            const id = String(service?._id ?? service?.id ?? '');
            return !serviceIds.includes(id);
          }),
          selectedServiceIds: []
        }
      };
    }

    case GROUP_VULNS_EXPLORE_CLOSE:
      return {
        ...state,
        explore: { ...initialExploreState }
      };

    default:
      return state;
  }
}
